import { Button, IconButton } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { PROJECT_CURRENT_STEP } from '../../../constants/projectConstants'

interface RequestProps {
  title: string
  summary: string
  cost: string
}

const AddOnServices = ({ isRequestSummary }: AddOnServices) => {
  const dispatch = useDispatch()
  
  const { project } = useSelector((state: RootStateOrAny) => state.projectDetails)
  
  const Request = ({ title, summary, cost }: RequestProps) => {
    const [expanded, setExpanded] = useState(isRequestSummary)

    const handleExpandClick = () => {
      setExpanded(!expanded)
    }

    return (
      <div className="request">
        <div className="flex space-between">
          <div className="flex">
            <div>
              <IconButton
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
                className={`m-r-10 ${expanded ? 'rotate' : ''}`}
              >
                <ChevronRight />
              </IconButton>
            </div>
            <div className="p-r-60">
              <h4 className="m-b-0">{title}</h4>
              <p
                className={`m-b-0 gray-text fs14 ${
                  !expanded ? 'line-clamp one' : ''
                }`}
              >
                {summary}
              </p>
            </div>
            <div className="text-right">
              <h4 className="m-b-0 m-r-16">{cost}</h4>
              <Button
                color="primary"
                className="text"
                onClick={() =>
                  dispatch({
                    type: PROJECT_CURRENT_STEP,
                    payload: 8,
                  })
                }
              >
                Edit
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {project.addOnServices && (
        <>
          {project.addOnServices.onsiteDebugging && (
            <Request
              title="Onsite debugging"
              summary="We come to your facility to setup and verify the CMM measurement program. This may include modifying the program based on the actual fixturing scenario or measurement data, establishing the part location so operators can run the program without manually driving the CMM, and providing training for operators to successfully measure parts."
              cost="TBD"
            />
          )}
          {project.addOnServices.correlationGRR && (
            <Request
              title="Correlation GR+R"
              summary="If you have data you need the CMM data to correlate to, we will work with you to align the measurement strategies so they are both accurate and provide consistent results.  We can also perform Gage Repeatability and Reproducibility (GR&R) studies to validate the entire measurement system."
              cost="TBD"
            />
          )}
          {project.addOnServices.fixtureDesign && (
            <Request
              title="Fixture design"
              summary="Hexagon will evaluate your prints to determine the best way to fixture your part to replicate the datum structures. Based on your requirements we will source the creation of your custom holding fixture."
              cost="TBD"
            />
          )}
          {project.addOnServices.premiumSupport && (
            <Request
              title="Premium support"
              summary="Part of the MyCare package. Receive a block of virtual support hours with a Hexagon Application Engineer to help you overcome small hurdles. Please note that these hours cannot be used for onsite support or training."
              cost="TBD"
            />
          )}

          {project.addOnServices.classroomOrVirtualSupport && (
            <Request
              title="Classroom or virtual training"
              summary="Receive best-in-class training from a Hexagon AE at your closest solution center or virtually. Classes include PCDMIS Level 1-3, portable or stationary. Please note that training may also incur travel expenses based on your location to the nearest solution center."
              cost="TBD"
            />
          )}

          {project.addOnServices.customOnsiteTraining && (
            <Request
              title="Custom onsite training"
              summary="Receive best-in-class training from a Hexagon AE at your facility. Classes include PCDMIS Level 1-3, portable or stationary. Please note that onsite training may also incur travel expenses based on your location to the nearest solution center."
              cost="TBD"
            />
          )}
        </>
      )}
    </>
  )
}

export default AddOnServices
